import * as React from 'react'
import { 
    title,
    intro,
    subtitle,
    container,
    byline
 } from './header1.module.css'
 
const Header1 = ({ pageTitle, pageSubtitle, introText }) => {
   
    return (
        <header className = {container}>
            <h1 className = {title}>{pageTitle}</h1>
            <h2 className = {subtitle}>{pageSubtitle}</h2>
            <h3 className = {byline}></h3>
            <p className = {intro}>{introText}</p>
        </header>
    )
}

export default Header1 